/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFlexGroup, EuiFlexItem, EuiLink } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import type { FunctionComponent } from 'react'

type Props = {
  organizationId: string
}

const OrganizationAuditLogLink: FunctionComponent<Props> = ({ organizationId }) => (
  <EuiFlexGroup gutterSize='s' alignItems='center' responsive={false}>
    <EuiFlexItem grow={false}>
      <EuiLink href={getDashboardHref(organizationId)} target='_blank'>
        <FormattedMessage
          id='organization.organization-overview.organization-audit-log-link.dashboard-label'
          defaultMessage='Audit logs for API and User Console actions'
        />
      </EuiLink>
    </EuiFlexItem>
    <EuiFlexItem grow={false}>
      <EuiLink href='https://ela.st/cloud-console-audit-logs' target='_blank' external={false}>
        <FormattedMessage
          id='organization-audit-log-link.details-label'
          defaultMessage='(Details)'
        />
      </EuiLink>
    </EuiFlexItem>
  </EuiFlexGroup>
)

function getDashboardHref(organizationId: string) {
  return `https://platform-logging.kb.us-east-1.aws.found.io/app/discover#/?_g=(time:(from:now-24h,to:now))&_a=(columns:!(request_method,request_url,status_code,request_length,response_length,response_time),filters:!(),index:'service-adminconsole-*,logs-iam-service.log-*',query:(language:lucene,query:'organization_id:${organizationId}'),sort:!(!('@timestamp',desc)))`
}

export default OrganizationAuditLogLink
